const SAFE_ORIGIN = "https://getcleaniq.invalid";

const EXACT_AUTH_DESTINATIONS = new Set([
  "/dashboard",
  "/onboarding",
  "/insights",
  "/billing",
  "/team",
  "/support",
  "/calia",
  "/connect",
  "/admin/command-center",
  "/admin/security",
  "/admin/audit",
  "/admin/crm-operations",
  "/admin/access",
  "/admin/configuration",
  "/admin/jobs",
  "/admin/analytics",
  "/admin/intelligence",
  "/admin/support",
]);

const DYNAMIC_AUTH_DESTINATIONS = [
  /^\/checkout\/(?:starter|growth|pro)$/,
  /^\/scans\/[A-Za-z0-9_-]+$/,
  /^\/admin\/center\/[a-z0-9-]+$/,
];

function decodeRepeatedly(value) {
  let decoded = value;
  for (let pass = 0; pass < 4; pass += 1) {
    const next = decodeURIComponent(decoded);
    if (next === decoded) return decoded;
    decoded = next;
  }
  return decoded;
}

export function safeAuthDestination(value) {
  if (typeof value !== "string" || !value) return "";

  let decoded;
  try {
    decoded = decodeRepeatedly(value);
  } catch {
    return "";
  }

  if (
    !decoded.startsWith("/") ||
    decoded.startsWith("//") ||
    decoded.includes("\\") ||
    /[\u0000-\u001F\u007F]/.test(decoded)
  ) {
    return "";
  }

  let parsed;
  try {
    parsed = new URL(decoded, SAFE_ORIGIN);
  } catch {
    return "";
  }

  if (parsed.origin !== SAFE_ORIGIN) return "";

  const allowed =
    EXACT_AUTH_DESTINATIONS.has(parsed.pathname) ||
    DYNAMIC_AUTH_DESTINATIONS.some((pattern) => pattern.test(parsed.pathname));

  return allowed ? `${parsed.pathname}${parsed.search}` : "";
}
